import getLogger from '@ignitesales/logger-es';

const logger = getLogger({ modules: 'validateQuestion' });

const validateQuestion = (question, value) => {
  let errors;

  const vv = question.validations || [];
  for (let v of vv) {
    switch (v.type) {
      case 'required': {
        if (value === undefined || (Array.isArray(value) && value.length === 0)) {
          errors = {
            [v.type]: []
          };
        }
        break;
      }
      case 'between': {
        if (value < v.min || value > v.max) {
          errors = {
            [v.type]: [ v.min, v.max ]
          };
        }
        break;
      }
      case 'postalCode': {
        // eslint-disable-next-line security/detect-unsafe-regex
        if (!/^[0-9]{5}(?:-[0-9]{4})?$/.test(value)) {
          errors = {
            [v.type]: []
          };
        }
        break;
      }
      case 'emailAddress': {
        // eslint-disable-next-line security/detect-unsafe-regex
        if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
          errors = {
            [v.type]: []
          };
        }
        break;
      }
      default: {
        logger.warn(`Unknown question validation type ${ v.type }`);
      }
    }
  }

  return errors;
};

export default validateQuestion;
